export default __webpack_public_path__ + "static/media/LakeBunyonyi.2296a969.png";